import { Component, Input } from "@angular/core";

@Component({
  selector: "med-external-link[url]",
  templateUrl: "./med-external-link.component.html",
  styleUrls: ["./med-external-link.component.scss"],
})
export class MedExternalLinkComponent {
  @Input() url!: string;
  @Input() target = "_blank";
  @Input() showTrident = false;
}
